import React, { useContext, useEffect } from 'react'
import Layout from '../../../components/layout/layout'
import '../mlOutRails/mlOutRails.scss'
import coverImage from '../../../images/articles/dataprivacy-photo.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'


const DataPrivacy = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Seo
        title='AI and Data Privacy: Building Trusted Models'
        description={translations.BlogDataPrivacy1}
        type='article'
        image={coverImage}
        jsonLd={[
          articleJsonLd({
            headline: translations.BlogDataPrivacy,
            description: translations.BlogDataPrivacy1,
            image: coverImage,
            path: '/articles/dataPrivacy',
            datePublished: '2026-04-08',
            author: translations.BlogDataPrivacy12,
          }),
          articleBreadcrumbs(translations.BlogDataPrivacy, '/articles/dataPrivacy'),
        ]}
      />
      <div className='mlrole-health-container'>

        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.BlogDataPrivacy}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.BlogDataPrivacy11}</p>
              <p>•</p>
              <p>{translations.BlogDataPrivacy12}</p>
            </div>
            <p className='article-author-head'>{translations.BlogDataPrivacy13}</p>
          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={coverImage} alt='Rows of servers in a data center' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='dataPrivacy' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.BlogDataPrivacy1}</p>
              <p>{translations.BlogDataPrivacy2}</p>

              <h2 className='article-secondaty-title'>{translations.BlogDataPrivacy3}</h2>
              <p>{translations.BlogDataPrivacy4}</p>
              <p>{translations.BlogDataPrivacy5}</p>
              <p>{translations.BlogDataPrivacy6}</p>

              <h2 className='article-secondaty-title'>{translations.BlogDataPrivacy7}</h2>
              <p>{translations.BlogDataPrivacy8}</p>
              <p>{translations.BlogDataPrivacy9}</p>
              <p>{translations.BlogDataPrivacy10}</p>
            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/mlEcommerce' title={translations.BlogMlEcommerce} />
        </div>
      </div>
    </Layout>
  )
}

export default DataPrivacy
